'use client';
import {
  HomeDataInterface,
  ProductDetailType,
} from '@/lib/type/home-data.type';
import { WeiboShareButton, WeiboIcon, WhatsappShareButton, WhatsappIcon } from "react-share";
import { Button, message } from 'antd';
import ImageGallery from '@/app/product/ImageGallery';
import TypeSelection from '@/app/product/TypeSelection';
import Link from 'next/link';
import ProductCount from '@/components/product/count';
import { useShopCart } from '@/hooks/useShopCart';
import { useEffect, useState } from 'react';
import { ProductSkuType } from '@/lib/type/product.type';
import { requestCancelCollectProduct, requestCollectProduct, requestMyCollect } from '@/lib/api/product';
import { getUserCookies } from '@/service/action/user-cookies';
import { debounce, sleep } from '@/lib/util/util';
import { useRouter } from 'next/navigation';
import { getLoginLink, getCheckoutLink } from '@/lib/util/get-router';
import { useCheckoutStore } from '@/lib/store/checkout';
import clsx from 'clsx';
import CustomizedModel from '@/app/product/ProductUp/CustomizedModel';

type Props = {
  currentProduct: ProductDetailType | undefined;
  product: any
  types: string[]
  embedPartNumberData: any
  changeEmbedPartNumberData: (id: string) => void
  resetEmbedPartNumberData: () => void
};
const ShareBar = ({ product }: { product: any }) => {
  console.log(product, 'product');

  // 分享配置（自动获取产品链接/标题）
  const shareUrl = product?.slug 
    ? `https://www.hpdfa.com/product/${product.slug}` 
    : "https://www.hpdfa.com";
    
  const shareTitle = product?.name || "鼎尖精密五金配件定制、原型设计、批量生产";
  const shareSummary = "鼎尖精密五金配件定制、原型设计、批量生产";

  // 分享按钮列表：微信 → 替换为 WhatsApp
  const iconList = [
    {
      type: "whatsapp",
      bgColor: "#25D366", // WhatsApp 官方绿

    },
    {
      icon: "ri-qq-fill",
      bgColor: "#68a5e1",
      type: "qq",
      isButton: true,
    },
    {
      icon: "ri-weibo-fill",
      bgColor: "#f56467",
      type: "weibo",
    },
  ];

  // 点击分享
  const handleShare = (type: string) => {
    if (type === "qq") {
      const qqUrl = `https://connect.qq.com/widget/shareqq/index.html?url=${encodeURIComponent(shareUrl)}&title=${encodeURIComponent(shareTitle)}&desc=${encodeURIComponent(shareSummary)}`;
      window.open(qqUrl, "_blank");
    }
  };

  return (
    <div style={{ display: "flex", gap: 12 }}>
      {iconList.map((item, idx) => (
        <div
          key={idx}
          onClick={() => handleShare(item.type)}
          style={{
            width: "20px",
            height: "20px",
            backgroundColor: item.isButton ? item.bgColor : "transparent",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            color: "#fff",
            fontSize: "14px",
            borderRadius: "2px", // 轻微圆角更美观
          }}
        >
          {/* WhatsApp 用 react-share 官方组件 */}
          {item.type === "whatsapp" ? (
            <WhatsappShareButton url={shareUrl} title={shareTitle}>
              <WhatsappIcon size={20} iconFillColor="#fff" />
            </WhatsappShareButton>
          ) : item.type === "weibo" ? (
            <WeiboShareButton url={shareUrl} title={shareTitle}>
              <WeiboIcon size={20} iconFillColor="#fff" />
            </WeiboShareButton>
          ) : (
            <i className={clsx(item.icon)} />
          )}
        </div>
      ))}
    </div>
  );
};
export default function ProductDataShow(props: Props) {
  const { addToCart } = useShopCart();
  const router = useRouter();
  const { setCheckoutData, setCheckoutType } = useCheckoutStore();
  const data = props.currentProduct;
  // antd的全局提示
  const [messageApi, contextHolder] = message.useMessage();
  const types = props.types;


  // 用户是否完成选型
  const [isFinishTypeSelect, setIsFinishTypeSelect] = useState(false);
  // 用户完成选型的产品
  const [selectSkuType, setSelectSkuType] = useState<ProductSkuType>();
  const selectAction = (data: boolean) => {
    setIsFinishTypeSelect(data);
  };
  const selectTypeAction = (data: ProductSkuType) => {
    setSelectSkuType(data);
  };
  // 用户选择的产品数量
  const [startNum, setStartNum] = useState(1);



  const [successCollect, setSuccessCollect] = useState(false);

  // 收藏
  const collectAction = debounce(async (id: string) => {
    console.log(successCollect, 'successCollect');

    const userInfo = await getUserCookies();
    if (!userInfo) {
      messageApi.open({
        type: 'warning',
        content: '请先登录',
      });
      return;
    }

    if (successCollect) {
      //取消收藏
      const res = await requestCancelCollectProduct(
        { topic_id: Number(id), "access-token": userInfo.access_token }
      );
      if (res.code === 200) {
        setSuccessCollect(false);
        return messageApi.open({
          type: 'success',
          content: '取消收藏成功',
        });
      }
      messageApi.open({
        type: 'warning',
        content: '取消收藏失败',
      });
    } else {
      //收藏
      const res = await requestCollectProduct(
        { topic_id: id, topic_type: 'product' },
        { 'access-token': userInfo.access_token }
      );
      if (res.code === 200) {
        setSuccessCollect(true);
        return messageApi.open({
          type: 'success',
          content: '收藏成功',
        });
      }
      messageApi.open({
        type: 'warning',
        content: '收藏失败',
      });
    }
  }, 500);

  // 获取我的收藏
  const getMyCollectAction = async () => {
    const userInfo = await getUserCookies();
    if (!userInfo) return;
    const res = await requestMyCollect({
      'access-token': userInfo.access_token,
    });
    if (res.code === 200) {
      const result = res.data.find((item) => item.id === data?.id);
      setSuccessCollect(!!result);
    }
  };
  useEffect(() => {
    data && getMyCollectAction();
  }, [data]);

  // 用户点击加入购物车
  const addToCartAction = async () => {
    const userInfo = await getUserCookies();
    if (!props.embedPartNumberData?.id) {
      messageApi.open({
        type: 'warning',
        content: '请先完成产品选型',
      });
      return;
    }
    if (!userInfo?.access_token) {
      messageApi.open({
        type: 'warning',
        content: '请先登录',
      });
      return;
    }
    // messageApi.open({
    //     type: 'loading',
    //     content: 'Loading...',
    // });

    console.log(selectSkuType, 'selectSkuType', props);


    addToCart({ sku_id: props.embedPartNumberData?.id, number: startNum });
  };

  // 用戶点击一键购买
  const buyAction = async () => {
    const userInfo = await getUserCookies();
    if (!props.embedPartNumberData?.id) {
      messageApi.open({
        type: 'warning',
        content: '请先选择产品型号',
      });
      return;
    }
    if (!userInfo?.access_token) {
      messageApi.open({
        type: 'warning',
        content: '请先登录',
      });
      return;
    }
    setCheckoutData([{ ...props.embedPartNumberData, count: startNum }]);
    setCheckoutType(1);
    await sleep(500);
    const link = getCheckoutLink();
    router.push(link);
  };

  let [T3dUrl, setT3dUrl] = useState(props.product['3d_url'] || '')

  // console.log(data, 'data99');
  function changesetT3dUrl(url: string) {
    setT3dUrl(url)
  }

  return (
    <div className="bg-white p-6 mb-6">
      {/* <h1 onClick={asd}>222</h1> */}
      <div className="flex">
        {/*商品图片*/}
        <div className="">
          <ImageGallery data={data?.covers} product={data} T3dUrl={T3dUrl}></ImageGallery>
        </div>

        {/*右边数据部分*/}
        <div className="flex-1 ml-10 flex flex-col">
          <div className="b-flex border-b border-[#e6e6e6] mb-6">
            <div>
              <h3 className="mb-4 font-black text-xl">{data?.name}</h3>
            </div>
          </div>

          <div className="flex-1 flex flex-col">
            <TypeSelection
              embedPartNumberData={props.embedPartNumberData}
              changeEmbedPartNumberData={props.changeEmbedPartNumberData}
              resetEmbedPartNumberData={props.resetEmbedPartNumberData}
              spec_format={data?.spec_format}
              sku={data?.sku}
              selectAction={selectAction}
              selectTypeAction={selectTypeAction}
              product={data}
              changesetT3dUrl={changesetT3dUrl}
              types={types}
            />
          </div>
        </div>
      </div>

      <div className="flex items-center justify-between  mt-6">
        <div className="flex items-center ">
          <span className="text-[#999]">图片仅供参考</span>
          {data && (
            <div
              className="mx-8 cursor-pointer"
              onClick={() => {
                collectAction(data.id);
              }}
            >
              {successCollect ? (
                <i className="ri-star-fill text-main"></i>
              ) : (
                <i className={`ri-star-line`}></i>
              )}

              <span>{successCollect ? '已收藏' : '收藏'}</span>
            </div>
          )}

          <div className="c-flex gap-x-3">
            <span>分享到</span>
            <ShareBar product={data} />
            <p></p>
          </div>
        </div>

        <div className="b-flex ml-32">
          <div className="flex items-center">
            <span>数量</span>
            <ProductCount
              startNum={startNum}
              changeNum={setStartNum}
            />
            {data?.unit && <span>({data?.unit})</span>}
          </div>
          {contextHolder}
          <div className="flex items-center">
            <CustomizedModel />
            <div
              className="bg-[#24a7cf] px-2 h-[40px] text-white c-flex mr-6 cursor-pointer !text-[10px]"
              onClick={() => addToCartAction()}
            >
              加入购物车
            </div>
            <div
              className="bg-[#ff5f00] px-2 h-[40px] text-white c-flex cursor-pointer !text-[10px]"
              onClick={() => buyAction()}
            >
              <span>一键购买</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
